export default __webpack_public_path__ + "static/media/default.4ef2e9bc47d227d73452e27f8c30dab4.png";